// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  quickShopModal: document.querySelector('quick-shop'),
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
  cartCloseBtn: document.querySelector('.close-ajax--cart'),
  cartTotal: document.querySelector('#ajax-cart [data-cart-total]')
};

class AjaxCart extends HTMLElement {
    constructor() {
      super();
  
      this.openeBy = drawerSelectors.cartIcons;
      this.isOpen =  this.classList.contains('open--drawer');
      this.cartForm = this.querySelector('form');
      this.sectionID = 'component-cart-drawer';
      this.bxgyDiscountDetails;

      if(window.globalVariables.template == 'cart'){
        this.style.visibility = 'visible';
        this.sectionID = document.getElementById('cart--items').dataset.id;
      }else{
        this.addAccessibilityAttributes(this.openeBy);
        this.getCartData();
      }

      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
  
    connectedCallback() {
      this.bindEvents();
      this.cartNoteInput();
    }

    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }
  
    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, _oldValue, newValue) {
      // called when one of attributes listed above is modified
      if(name === 'updating' && newValue === 'false'){
        this.updateEvents();
      }
    }
  
    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
      let _this = this;
      openDrawerButtons.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', _this.id);
      });
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      drawerSelectors.cartCloseBtn.dispatchEvent(new Event('click'));
    }
  
    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
      if(window.globalVariables.template !== 'cart'){
        this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        drawerSelectors.cartCloseBtn.addEventListener('click', this.closeCartDrawer.bind(this));
      }
      this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents(){
      this.querySelectorAll('[data-item-remove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
      this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
      this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', this.onQtyChange.bind(this)));
    }

    async getUpsell() {
  
      let cartData = await this.fetchCart();
      if(cartData.items.length > 0 && this.querySelector('.cart-related_items') != null){
        let productId = cartData.items[0].product_id;
        let related_products = await this.getRecommendedProducts(productId);
        if(related_products.length > 0){
          let upsellHTML = this.upsellHTML(related_products);
          this.querySelector('.cart-related_items').innerHTML = upsellHTML;
          this.dynamicEleEvents();
          this.querySelector('.cart-related_loader').classList.remove('loading')
          this.querySelector('.cart_related-products').classList.remove('d-none')
          this.optionSelection();
          this.addUpsell();
        } 
      } else {
        this.querySelector('.cart_related-products')?.classList.add('d-none')
      }
      
    
    }
    
    fetchCart() {
      return new Promise((resolve, reject) => {
        fetch('/cart.js', { method: 'GET' })
          .then(response => response.json())
          .then(cartData => {
            resolve(cartData);
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
            reject(error);
          });
      });
    }

    getRecommendedProducts(productId){
      return new Promise((resolve, reject) => {
        fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`)
          .then(response => response.json())
          .then(({ products }) => {
            if (products.length > 0) {
              resolve(products);
            } else {
              reject(new Error('No recommended products found.'));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }

    upsellHTML(related_products){
      var btnHTML ='';
      let productHTML = "";
      related_products.forEach(related_product => {
        var allProductOptions = "";
        for(const option of related_product.options){
          let optionHtml = ``;
          let isOptions = false;
          for (const value of option.values) { 
            if(value != 'Default Title'){
              isOptions = true;
              let temp = `<option value="${value}">${value}</option>`;
              optionHtml += temp;
            }
          }
          if(isOptions){
            btnHTML = `
              <button
                class="btn btn-outline-secondary btn-sm flex-grow-1 px-2 quickshop--button"
                type="button"
                data-handle="${related_product.handle}"
                title="${related_product.handle}"
                aria-label="${related_product.handle}"
                data-toggle="tooltip"
                data-trigger="hover"
                data-placement="top"
                >
                <span class="add-text">Quick add</span>
              </button>`

            // let tempHtml = `
            //   <div class="">
            //     <h6 class="fs-sm form__label fw-bold lh-sm ls-sm mb-0 text-primary text-uppercase pe-2" >${option.name}:</h6>
            //     <select class="form-select bg-white" data-option-select>
            //       ${optionHtml}
            //     </select>
            //   </div>
            // `;
            // allProductOptions += tempHtml;
          }
          else{
            btnHTML = `
            <button class="btn btn-outline-secondary btn-sm flex-grow-1 px-2"
              type="submit"
              data-add-upsell-btn
              >
              <span class="add-text">
                ${related_product.variants[0].available ? `Add` : 'Out Of Stock'}
              </span>
              <span class="spinner-border"></span>
            </button>`
          }
        }

        productHTML += `
        <div class="cart-related_item h-auto d-flex swiper-slide h-auto d-flex">
          <div class="card card-product card-product-style-2 text-start rounded-0 border-0 h-100 flex-row" data-product-grid>
            <div class="card-img text-center" >
              <a href="${related_product.url}" class="d-block product-link rounded-2 overflow-hidden" >
                ${ related_product.featured_image ? `<img
                src="${related_product.featured_image}&width=250"
                loading="lazy"
                data-feauredImage
                alt="${related_product.title}"
                width="250"
                height="250"
              >` : `<img srcset="//joola-usa.myshopify.com/cdn/shop/files/Blog-Default-Missing-Featured-Image.jpg?v=1710415346&amp;width=230" 
              loading="lazy" src="//joola-usa.myshopify.com/cdn/shop/files/Blog-Default-Missing-Featured-Image.jpg?v=1710415346" 
              alt="joola-default-image" width="610" height="610.0">` }
              </a>
            </div>
            <div class="card-body ps-3 pt-0 pb-0 pe-0">
              <div class="row no-gutter">
                <div class="col-12">
                  <h6 class="card-title font-family-base fs-sm mb-0 mt-2 pt-1 text-capitalize">
                     <a href="${related_product.url}">${related_product.title}</a>
                  </h6>
                  <div class="row ps-0 pe-0 cart-dropdown">
                    ${allProductOptions}
                  </div>
                </div>
                <div class="col-12 text-start pb-05 mt-auto">
                  <span class="price m-0 pb-0 money fs-xs fw-medium text-body" data-currentPrice>
                    ${Utility.formatMoney(related_product.variants[0].price)}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div class="col-12 pt-1">
                <upsell-form>
                  <input type="hidden" name="id" value="${related_product.variants[0].id}" data-upsell-variant-id>
                  <div class="row">
                    <div class="col-12 d-flex">
                      ${btnHTML}
                    </div>
                  </div>
                </upsell-form>
              </div>
            </div>
          </div>
          <script data-upsell-products-json type="application/json">
            ${JSON.stringify(related_product)}
          </script>
        </div>
        `
      });
      return productHTML;
    }

  
    dynamicEleEvents(){
      if(drawerSelectors.quickShopModal && typeof drawerSelectors.quickShopModal.updateEvents == 'function'){ 
        drawerSelectors.quickShopModal.updateEvents(); 
      }
    }


    optionSelection(){
      let optionDropdowns = document.querySelectorAll('[data-option-select]');
      optionDropdowns.forEach(optionDropdown => {
        optionDropdown?.addEventListener('change', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
         
          let options = this._getOptionsFromSelect(event);
      
          let producData = JSON.parse(event.target.closest('.cart-related_item').querySelector('[data-upsell-products-json]').innerText);
          let variantsArray = producData.variants;
          let selectedVariant;
          variantsArray.find((variant) => {
            let mappedValues = variant.options.map((option, index) => {
              return options[index] === option;
            });
      
            if(!mappedValues.includes(false)){
              selectedVariant = variant;
            }
          });
         
          if(selectedVariant){
            event.target.closest('.cart-related_item').querySelector('[data-upsell-variant-id]').value = selectedVariant.id;
          }

          
        })
      })
    }
    _getOptionsFromSelect(event) {
      let options = [];
      event.target.closest('.cart-related_item').querySelectorAll('[data-option-select]').forEach((selector)=>{
        options.push(selector.value);
      });
      return options;
    }

    addUpsell(){
      let addBtns = document.querySelectorAll('[data-add-upsell-btn]');
      addBtns.forEach(el=> {
        el.addEventListener('click', (event) => {
          event.stopImmediatePropagation();
          event.preventDefault();
          let $form = event.target.closest('upsell-form');
          $form.querySelector('[type="submit"]').classList.add('loading');
          let variantID = event.target.closest('upsell-form').querySelector('input').value;
          let body = JSON.stringify({
            "id":parseInt(variantID),
            "quantity":1
          });
          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((res) => {
            let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
            if(dataJSON.errors){
              window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
                type: 'error',
                timeout: 5000
              });
            }
      
            document.querySelector('cart-form').getCartData('open_drawer');
           
          })
          .catch((e) => {
            window.notificationEle.updateNotification('Error', e, {
              type: 'error',
              timeout: 5000
            });
            console.error(e);
          })
          .finally(() => {
            $form.querySelector('[type="submit"]').classList.remove('loading');
            $form.querySelector('[type="submit"]').removeAttribute('disabled');
          });
        });
      });

     
    }
    
  
    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
      if(!window.globalVariables.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
  
      if(document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      }
  
      this.classList.add('opened-drawer');
      siteOverlay.prototype.showOverlay();
      Utility.forceFocus(this.querySelector('.cart-title'));
      Utility.trapFocus(this, drawerSelectors.cartCloseBtn);
  
      if(event){
        event.preventDefault();
        let openBy = event.currentTarget;
        openBy.setAttribute('aria-expanded', true);
      }
    }
  
    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
      if (event == undefined) return;

      event.preventDefault();
      this.classList.remove('opened-drawer');
      siteOverlay.prototype.hideOverlay();

      let openByEle = event.currentTarget;
      openByEle.setAttribute('aria-expanded', false);
      Utility.removeTrapFocus(elementToFocus);

      let actionBtn = drawerSelectors.cartIconDesktop;
      if(window.innerWidth < 1024){
        actionBtn = drawerSelectors.cartIconMobile;
      }
      Utility.forceFocus(actionBtn);
    }
  
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action){
      if(response === null) return;

      this.setAttribute('updating', true);

      return new Promise((resolve) => {
        let cartHTML = response[this.sectionID];
        let parser = new DOMParser();
        cartHTML = parser.parseFromString(cartHTML, 'text/html');
        resolve(cartHTML);
      })
      .then((cartHTML) => {
        const cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
        window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);

        const cartElement = cartHTML.querySelector('form');
        this.cartForm.innerHTML = cartElement.innerHTML;

        const cartTotal = Utility.formatMoney(
          window.globalVariables.cart.total_price,
          window.globalVariables.money_format
        );
        drawerSelectors.cartTotal.innerHTML = cartTotal;

        const cart_items_count = cartHTML.querySelector('[data-item-count]');
        if (cart_items_count) {
          this.querySelector('[data-item-count]').innerHTML = cart_items_count.innerHTML;
        }

        const elements = this.querySelectorAll('[data-checkoutBtns], [data-cartnote]');
        const cart_container = this.querySelector('.cart-form-container');

        if (window.globalVariables.cart.item_count <= 0) {
          elements.forEach((div) => div.classList.add('d-none'));
          cart_container.classList.add('empty_cart', 'd-flex', 'flex-column');
        } else {
          elements.forEach((div) => div.classList.remove('d-none'));
          cart_container.classList.remove('empty_cart', 'd-flex', 'flex-column');
        }

        return response['header'];
      })
      .then((headerHTMLString) => {
        const headerHTML = new DOMParser().parseFromString(headerHTMLString, 'text/html');
        const cartIcon = headerHTML.getElementById('cart-icon-desktop');

        if (drawerSelectors.cartIconDesktop) {
          drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
        }
        if (drawerSelectors.cartIconMobile) {
          drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;
        }
      })
      .then(() => {
        if (
          window.globalVariables.template !== 'cart' &&
          window.globalVariables.cart_drawer &&
          action === 'open_drawer'
        ) {
          this.openCartDrawer();
        }
      })
      .catch((e) => console.error('[UpdateCart Error]', e))
      .finally(() => this.setAttribute('updating', false));
    }

    getBxgyDetails(){
      if(Array.isArray(this.bxgyDiscountDetails)) return this.bxgyDiscountDetails;
      return fetch(`https://${window.location.hostname}/apps/joola-app/buy-x-get-y-discounts`, { method: "POST" })
      .then(response=>response.json())
      .then((data) => {
        if(data.error) {
          this.bxgyDiscountDetails = [];
          return this.bxgyDiscountDetails
        }
        this.bxgyDiscountDetails = data;
        return this.bxgyDiscountDetails;
      })
    }
    
    addBxgyProduct(products){
      if(products.length == 0) return Promise.resolve();
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items': products.map((_)=>({
            id:_.variantId,
            quantity:_.quantity
          }))
        })
      })
      .then(response => response.json())
    }

    removeBxgyProduct(products){
      if(products.length == 0) return Promise.resolve();
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify ({
          updates: products.reduce((acc,item)=>{
            acc[item.id] = 0;
            return acc;
          }, {})
        })
      })
    }

    handleBxgyDetails(bxgyDetails,cart){
      const bxgyCartDetails = bxgyDetails.map(({configuration, discount:details}) => {
        const discount = {}
        discount.title = details.title
        discount.x = {
          id: configuration.jsonValue.productX.map(product=>product.split("/").pop()),
          qty: 1
        }
        discount.y = {
          id:  configuration.jsonValue.productY.split("/").pop(),
          qty: 1
        }
        discount.x.line = cart.items.filter(({variant_id})=>discount.x.id.includes(`${variant_id}`));
        discount.x.totalQtyInCart = discount.x.line.reduce((acc,curr) => acc + curr.quantity , 0)
        discount.y.line = cart.items.filter(({variant_id})=>variant_id == discount.y.id);
        discount.y.totalQtyInCart = discount.y.line.reduce((acc, curr) => acc + curr.quantity, 0);
        if(discount.x.totalQtyInCart > discount.y.totalQtyInCart){
          const qtyVariation = discount.x.totalQtyInCart - discount.y.totalQtyInCart;
          if(qtyVariation > 0){
            discount.correction = {
              operation: "add",
              quantity: qtyVariation,
              id: discount.y.id
            }
          }
        }
        return discount;
      });
      const operations = bxgyCartDetails.map(({correction})=>{
        if(!correction) return Promise.resolve();
        if(correction.operation == 'add'){
          return this.addBxgyProduct([{
            variantId:correction.id,
            quantity:correction.quantity,
          }])
        }
      })
      return Promise.all(operations);
    }

    /**
     * Fetch latest cart data 
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action) {
    Promise.all([this.getBxgyDetails(), fetch(window.Shopify.routes.root + 'cart.js').then(res=>res.json())])
    .then(([bxgyDetails, cartDetails]) => {
      if(window?.customer?.b2b){
        return Promise.resolve()
      }else{
        return this.handleBxgyDetails(bxgyDetails, cartDetails)
      }
    })
    .then(()=>fetch(`${window.location.pathname}?sections=${this.sectionID},header`))
    .then(response => response.json())
    .then(response => {
      return Promise.all([
        this._updateCart(response, action),
        this.getUpsell()
      ])
    })
    .catch((e) => {
      console.error(e)
      return [];
    })
    }
  
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
      let lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

      if(lineItem){ lineItem.classList.add('updating'); }
      const body = JSON.stringify({
        line,
        quantity
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
      .then((response) => {
          return response.text();
      })
      .then((_state) => {
        let dataJSON = ((typeof res == 'object') ? _state : JSON.parse(_state));
        if(dataJSON.errors){
          window.notificationEle.updateNotification('Cart Update', dataJSON.errors, {
            type: 'error',
            timeout: 5000
          });
        }
        return Promise.all([this.getCartData(),this.getUpsell()])
      }).catch((error) => {
        window.notificationEle.updateNotification('Cart Update', error, {
          type: 'error',
          timeout: 5000
        });
      }).finally(() => {
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 500);
      });
    }
  
    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removeItem(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      if(itemIndex !== null){
          this.updateItemQty(itemIndex, 0);
      }
      
    }
  
    /**
     * Cart Item Qunatity Increment/Decrement Button 
     * 
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;

      let stepQty = ($qtyInput.step) ? parseInt($qtyInput.step) : 1;
      let minQty = ($qtyInput.min) ? parseInt($qtyInput.min) : 1;
      let maxQty = ($qtyInput.max) ? parseInt($qtyInput.max) : null;

      let currentQty = parseInt($qtyInput.value) || minQty;
      let finalQty = currentQty;
  
      if(action === 'decrease' && currentQty <= minQty){
        return false;
      }else if(action === 'decrease'){
        finalQty = currentQty - stepQty;
      }else{
        finalQty = currentQty + stepQty;
      }

      this.updateItemQty(itemIndex, finalQty);
      
      // if(maxQty != null && finalQty <= maxQty && finalQty >= minQty){
      //   this.updateItemQty(itemIndex, finalQty);
      // }else if(finalQty >= minQty){ 
        
      // }
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event){
      const $qtyInput = event.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;
      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }

    /**
     * Manage Cart Notes
     */
    cartNoteInput(){
      const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
      if(!cartNoteEle) return;

      const cartNoteSave = document.querySelector('[data-saveNote]');
      let cartNoteEvents = ['input', 'paste'];
      cartNoteEvents.forEach((eventName)=>{
        cartNoteEle.addEventListener( eventName, (evt)=> {
          const defaultNote = cartNoteEle.dataset.default;
          if(defaultNote !== cartNoteEle.value){
            cartNoteSave.style.display = 'block';
          }else{
            cartNoteSave.style.display = 'none';
          }
        }, false);
      });

      //  Cart Note Change event
      cartNoteSave.addEventListener( "click", evt => {
        evt.preventDefault();
        const cartNoteContainer = evt.currentTarget.closest('[data-cartNote]');
        const cartNote = cartNoteContainer.querySelector('[name="note"]').value.trim();
        if(cartNote.length <= 0){
          alert('Add Note before proceeding');
          return;
        }
        
        const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
        const waitText = (submitBtn.dataset.adding_txt) ? submitBtn.dataset.adding_txt : 'Saving...';
        submitBtn.innerHTML = waitText;
        submitBtn.disabled = true;
        this.updateCartNote(cartNoteContainer);
      });
    }

    /**
     * Update Cart Note
     * @param {element} cartNoteContainer 
     */
    updateCartNote(cartNoteContainer){
      const _this = this;
      const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
      const cartNote = cartNoteEle.value.trim();
      const resultEle = cartNoteContainer.querySelector('[data-resultMsg]');
      const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
      const defaultText = (submitBtn.dataset.default) ? submitBtn.dataset.default : 'Save';

      let body = JSON.stringify({
        note: cartNote
      });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }
      }).then(function (data) {
        if (data.status === 200) {
          if(resultEle){
            resultEle.innerText = 'Added note to Order!';
            _this.manageResponseText(resultEle);
          }
          if(cartNoteEle){
            cartNoteEle.dataset.default = cartNote;
          }
          submitBtn.style.display = 'none';
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
        else {
          console.error('Request returned an error', data);
          if(resultEle){
            resultEle.innerText = data;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
      }).catch(function (error) {
          console.error('Request failed', error);
          if(resultEle){
            resultEle.innerText = error;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
      });
    }

    /**
     * fade effect on reponse
     * @param {element} element 
     */
    manageResponseText(element){
      Utility.fadeEffect(element, 'fadeIn');
      setTimeout(() => {
          Utility.fadeEffect(element, 'fadeOut');
      }, 3000);
    }
}
customElements.define("cart-form", AjaxCart);